import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Toolbar from '@tamagoshi/core/Toolbar';
import { getFooterContext } from '@context';
import { isB2BVisible } from '@constants';
import { B2BConnectMobile } from '../B2BConnect';
import Chat from '../Chat';

import styles from './styles/index.module.scss';

const Content = memo(({ Component, isVisible }) => {
  return isVisible ? (
    <Toolbar
      tag="div"
      size="xl"
      className={cn(styles.section, styles.mobileBlock)}
    >
      {Component}
    </Toolbar>
  ) : null;
});

Content.displayName = 'Content';

Content.propTypes = {
  isVisible: PropTypes.bool,
  Component: PropTypes.node.isRequired,
};

Content.defaultProps = {
  isVisible: true,
};

const Service = () => {
  const { isAuthenticated, isB2B, platform } = getFooterContext();
  const isVisible = isB2BVisible(platform, isAuthenticated, isB2B);

  return (
    <>
      <Content isVisible={isVisible} Component={<B2BConnectMobile />} />
      <Content Component={<Chat />} />
    </>
  );
};

export default Service;
